export default __webpack_public_path__ + "static/media/Lebenslauf.ba40eaca.pdf";